import {resolve} from "../../hook/resolver";
import axios from "axios";
import {LENOTRE_AUTOCOMPLETE} from "../../constants/apiService";

export const lenotreAutocomplete = async (token, data) => {
    return await resolve(axios.post(LENOTRE_AUTOCOMPLETE, data, {
        headers: {Authorization: `Bearer ${token}`}
    }).then(r => r.data));
}
